import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { bapi } from '@/lib/billingApi';
import { KpiTiles } from './KpiTiles';
import { RevenueChart } from './RevenueChart';
import { AlertsBanner } from './AlertsBanner';
import { TransactionsTable } from './TransactionsTable';
import { SubscriptionsTable } from './SubscriptionsTable';
import { GatewayStatusCard } from './GatewayStatusCard';
import { BillingSettingsForm } from './BillingSettingsForm';
import { PaypalBackfillCard } from './PaypalBackfillCard';
import { CardCheckoutSwitch } from './CardCheckoutSwitch';
import { TestChargeCard } from './TestChargeCard';

export const SalesTab = () => {
  const [summary, setSummary] = useState(null);
  const [months, setMonths] = useState(null);
  const [alerts, setAlerts] = useState([]);
  const [tick, setTick] = useState(0);
  const refresh = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    bapi('/admin/billing/summary').then(setSummary).catch((e) => toast.error(e.message));
    bapi('/admin/billing/monthly-revenue', { query: { months: 12 } }).then((d) => setMonths(d.months)).catch(() => setMonths([]));
    bapi('/admin/billing/alerts').then((d) => setAlerts(d.rows)).catch(() => {});
  }, [tick]);

  return (
    <div className="space-y-6" data-testid="sales-tab">
      <AlertsBanner rows={alerts} onResolved={refresh} />
      <KpiTiles s={summary} />
      <RevenueChart months={months} />
      <Tabs defaultValue={new URLSearchParams(window.location.search).get('sub') || 'transactions'}>
        <TabsList className="bg-white border border-slate-200 h-auto flex-wrap justify-start" data-testid="sales-subtabs">
          <TabsTrigger value="transactions" data-testid="sales-subtab-transactions">Transactions</TabsTrigger>
          <TabsTrigger value="subscriptions" data-testid="sales-subtab-subscriptions">Subscriptions</TabsTrigger>
          <TabsTrigger value="settings" data-testid="sales-subtab-settings">Gateway &amp; settings</TabsTrigger>
        </TabsList>
        <TabsContent value="transactions" className="mt-4"><TransactionsTable onChanged={refresh} /></TabsContent>
        <TabsContent value="subscriptions" className="mt-4"><SubscriptionsTable refreshKey={tick} /></TabsContent>
        <TabsContent value="settings" className="mt-4 space-y-6">
          <CardCheckoutSwitch />
          <TestChargeCard />
          <GatewayStatusCard onSwept={refresh} />
          <BillingSettingsForm />
          <PaypalBackfillCard />
        </TabsContent>
      </Tabs>
    </div>
  );
};
